export const moneyBrRegex = /(\R\${1}\s*(?:[1-9]\d{0,2}(?:\.\d{3})*|0)(?:,\d{1,2})?)$/g;

export const phoneRegex = /([0-9]{4,}).([0-9]{1,})|[0-9]{5,}/g;

